module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.imgVisible) ? _c('div', [_c('el-image-viewer', {
    staticStyle: {
      "z-index": "99999"
    },
    attrs: {
      "url-list": [_vm.fileInfo.url],
      "on-close": _vm.closePreviewer
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.fileInfo.name + '.' + _vm.fileInfo.type,
      "visible": _vm.previewAreaVisible,
      "width": _vm.previewAreaWidth + '%',
      "top": _vm.previewAreaTop + 'px',
      "append-to-body": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.previewAreaVisible = $event
      },
      "close": _vm.closePreviewer
    }
  }, [_c('div', {
    staticClass: "previewArea",
    style: ({
      height: _vm.previewAreaHeight + 'px'
    })
  }, [(_vm.txtVisible) ? _c('div', {
    staticClass: "txtArea"
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.txtContent)
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.pdfVisible) ? _c('div', {
    staticClass: "pdfArea"
  }, _vm._l((_vm.pdfPages), function(currentPage) {
    return _c('pdf', {
      key: currentPage,
      ref: "pdf",
      refInFor: true,
      attrs: {
        "src": _vm.pdfSrc,
        "page": currentPage
      }
    })
  }), 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "videoArea"
  }, [(_vm.initPlayerCompleted) ? _c('video-player', {
    ref: "videoPlayer",
    staticClass: "video-player vjs-custom-skin",
    attrs: {
      "playsinline": true,
      "x5-video-player-type": "h5",
      "x5-video-player-orientation": "landscape",
      "options": _vm.playerOptions
    }
  }) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "25px"
    }
  })])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2f3660ac"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/file/previewer.vue
// module id = 1801
// module chunks = 502